export { default as AnalyticsProvider } from './posthog';
